










































































import {State, Getter, Action, namespace} from 'vuex-class'
import {Vue, Prop, Component, Watch} from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import {IPermission} from '@/store/modules/views/permission/states'
import {RolePermissionList} from '@/store/modules/views/role/states'

@Component
export default class EditRoleDialog extends VueExtendedBaseComponent {

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get editUserDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.editRoleAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get isAdmin() {
    if (this.profileRole === 'ผู้ดูแลระบบ') {
      return true
    } else {
      return false
    }
  }

  get permissionList() {
    return this.PermissionList
  }

  @Getter('userprofile/getProfile')
  private profile!: any

  get rolePermissionList() {
    return this.RolePermissionList
  }

  get userProfile() {
    return this.profile
  }

  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private role!: { _id: string, name: string, requireCenter: boolean }
  private loading = false
  private urlRole = ''
  private urlRolePermission = ''
  private name = ''
  private roleId = ''
  private isRequireCenter = false
  private profileRole = ''
  private selectedPermission: Array<{
    id: string,
    type: string[],
  }> = []
  private rolePermission: Array<{_id: string, name: string, type: string[]}> = []
  private headers = [
    'สิทธิการใช้งาน',
    'สร้าง',
    'อ่าน',
    'แก้ไข',
    'ลบ',
  ]
  @Action('role/getRoleList')
  private getRoleList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
  }) => void


  @Action('permission/GetPermission')
  private getPermissionList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('role/GetRolePermissionList')
  private getRolePermissionList!: (path: string) => void

  @Getter('permission/itemLists')
  private PermissionList!: IPermission['result']

  @Getter('role/rolePermissionList')
  private RolePermissionList!: RolePermissionList[]

  private options = {
    page: 1,
    sortBy: ['key'],
    sortDesc: [false],
    itemsPerPage: 1000,
    search: '',
  }
  private userPermissionitems!: string[]

  public async created() {
    this.name = this.role.name || null
    this.roleId = this.role._id || null
    this.isRequireCenter = this.role.requireCenter || false
    this.profileRole = this.userProfile.role && this.userProfile.role.name || ''
    this.urlRole = `${process.env.VUE_APP_API_URL}/v1`
    this.urlRolePermission = `role-permission/${this.roleId}`
    this.userPermissionitems = []
    await Promise.all([
      this.gePermissionListFunc(),
      this.getRolePermissionFunc(this.urlRolePermission),
    ])
    this.mappingRolePermission()

  }

  private async gePermissionListFunc() {
    await this.getPermissionList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'key'),
        sortDesc: _.get(this.options, 'sortDesc[0]', false),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify({})).toString('base64'),
      },
    })
  }

  private async getRolePermissionFunc(path: string) {
    await this.getRolePermissionList(path)
  }

  private async editRoleAction() {
    this.loading = true
    const userData = {
      role: {
        _id: this.roleId,
        name: this.name,
        requireCenter: this.isRequireCenter,
      },
      permission: this.rolePermission,
    }
    try {
      if ((this.name !== this.role.name) || (this.isRequireCenter !== this.role.requireCenter)) {
        await HttpRequestServiceWithToken.putByLevel(this.urlRole, 'role/' + this.roleId, userData.role)
      }
      await HttpRequestServiceWithToken.putByLevel(this.urlRole, this.urlRolePermission, userData.permission)
      this.updateSnackbar({txt: 'แก้ไขหน้าที่' + this.name + 'สำเร็จ.', type: 'success'})
      await this.callback()
      this.loading = false
      this.closeDialog()
    } catch (e) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }

  private mappingRolePermission() {
    const rolePermissionlist = this.RolePermissionList
    const permissionList = this.PermissionList
    this.rolePermission = _.map(permissionList, (permission) => {
      const item = _.find(rolePermissionlist, (role) => {
       return  (role.permissionId === permission._id)
      })
      return {
        _id: permission._id,
        name: permission.name,
        type: item && item.type || [],
      }
    })
  }
}
